itsoftApp.createModule("animateScroll", ["windowResize"], function() {
    var maxMobileWidth = 767;
    var module = this;
    var loaded = false;
    var pageHeader = document.querySelector("[data-fixed='true']");
    var viewportSize = itsoftApp.utils.getViewportSize();

    var getViewportSize = function () {
      viewportSize = itsoftApp.utils.getViewportSize();
    }

    var startScroll = function (target, padding, speed, speedAsDuration) {
      var defaultPadding = 0;

      if (pageHeader) {
        if (!itsoftApp.commonVars.headerHeight) {
          itsoftApp.utils.getHeaderHeight();
        }

        if (target.hasAttribute("data-offset")) {
          if (viewportSize <= maxMobileWidth) {
            defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
          } else {
            defaultPadding = itsoftApp.commonVars.headerHeight + itsoftApp.commonVars.headerHeight / 2;
          }
        } else if (target.hasAttribute("data-offset-mobile") && viewportSize <= maxMobileWidth) {
          defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
        } else {
          defaultPadding = itsoftApp.commonVars.headerHeight;
        }
      }

      var settings = {
        offset: defaultPadding
      }

      if (speed) {
        settings.speed = speed;
      }

      if (speedAsDuration) {
        settings.speedAsDuration = speedAsDuration;
      }
      
      var scroll = new SmoothScroll();

      if (!document.body.classList.contains("is-popup-opened")) {
        scroll.animateScroll(target, "auto", settings);
      } else {
        setTimeout(function () {
          scroll.animateScroll(target, "auto", settings);
        }, 800)
      }
    }

    var load = function (target, padding, speed, speedAsDuration) {
      if (!loaded) {
        itsoftApp.loadScript("/assets/scripts/smoothScroll/smooth-scroll.min.js", function () {
          loaded = true;
          startScroll(target, padding, speed, speedAsDuration);
        });
      } else {
        startScroll(target, padding, speed, speedAsDuration);
      }
    }

    var initAnimateScroll = function (el, padding) {
      el.addEventListener("click", function (evt) {
        evt.preventDefault();
        var scrollId = evt.target.href;
      
        if (!scrollId || !(scrollId = scrollId.split('#')[1])) {
          return;
        }

        var target = document.querySelector('#' + scrollId);
        load(target);
      });
    }

    var links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    Array.prototype.forEach.call(links, function (el) {
      initAnimateScroll(el);
    });

    module.callback = load;

    itsoftApp.modules.windowResize.addEvent(getViewportSize);
});